import './App.css';
import WeatherForm from './components/weatherForm';
function App() {

  

  return (
    <div className="App">
      
     <WeatherForm/>
      
    </div>
  );
}

export default App;
